export default __webpack_public_path__ + "static/media/T5.cbc32268.jpg";